import {api} from './../../../system/api';

export default {
    updateWeightReal: (params) => api.put('bags/' + params.id + '/update-weight', {...params}, {singleRequest: true}),
};